import { requestFunnel } from '@/application/api';
import { authenticationService } from '@/application/services/api-clients/login-service';

const getOptions = () => ({ headers: authenticationService.authHeader() });

const getDataToBeAccounted = async type => {
  const result = await requestFunnel.get(`accounting/${type}`, getOptions());
  return result.data;
};

export const getTransactionsToBeAccounted = async () => getDataToBeAccounted('transactions');

export const getConsignmentsToBeAccounted = async () => getDataToBeAccounted('consignments');

export const getWalletsEntriesToBeAccounted = async () => getDataToBeAccounted('wallets-entries');

export const getBankEntriesToBeAccounted = async () => getDataToBeAccounted('bank-entries');

export const setWalletsEntriesAsAccounted = async walletsEntriesIds => {
  const result = await requestFunnel.patch('accounting/wallets-entries', { walletsEntriesIds }, getOptions());
  return result.data;
};
